import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { CreateNewProjectTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<CreateNewProjectTheme>;
const css = baseCss as ThemedCssFunction<CreateNewProjectTheme>;

export const CreateNewProject = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid white;
`;
